var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.25C16.4142 1.25 16.75 1.58579 16.75 2V3.2C16.75 3.61421 16.4142 3.95 16 3.95C15.5858 3.95 15.25 3.61421 15.25 3.2V2C15.25 1.58579 15.5858 1.25 16 1.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.05 8C20.05 7.58579 20.3858 7.25 20.8 7.25H22C22.4143 7.25 22.75 7.58579 22.75 8C22.75 8.41421 22.4143 8.75 22 8.75H20.8C20.3858 8.75 20.05 8.41421 20.05 8Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8637 4.07553C18.5708 4.36842 18.5708 4.84329 18.8637 5.13619C19.1566 5.42908 19.6315 5.42908 19.9244 5.13619L20.7729 4.28766C21.0658 3.99476 21.0658 3.51989 20.7729 3.227C20.48 2.9341 20.0051 2.9341 19.7122 3.227L18.8637 4.07553Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.773 12.773C21.0659 12.4801 21.0659 12.0052 20.773 11.7123L19.9245 10.8638C19.6316 10.5709 19.1567 10.5709 18.8638 10.8638C18.5709 11.1567 18.5709 11.6316 18.8638 11.9244L19.7123 12.773C20.0052 13.0659 20.4801 13.0659 20.773 12.773Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1363 4.07553C13.4292 4.36842 13.4292 4.84329 13.1363 5.13619C12.8434 5.42908 12.3685 5.42908 12.0756 5.13619L11.2271 4.28766C10.9342 3.99476 10.9342 3.51989 11.2271 3.227C11.52 2.9341 11.9949 2.9341 12.2878 3.227L13.1363 4.07553Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 22C5.35786 22 2 18.6421 2 14.5C2 10.3579 5.35786 7 9.5 7C13.5175 7 16.7973 10.1589 16.991 14.1284C17.3133 14.0446 17.6514 14 18 14C20.2091 14 22 15.7909 22 18C22 20.2091 20.2091 22 18 22H9.5Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8C19 9.07406 18.4356 10.0163 17.5871 10.5463C16.7079 8.7511 15.2488 7.29188 13.4539 6.41269C13.9838 5.56436 14.926 5 16 5C17.6569 5 19 6.34315 19 8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudSun);
export default __webpack_public_path__ + "static/media/cloud-sun.c98c3606840f256fef21480d28412d73.svg";
export { ForwardRef as ReactComponent };